import { Offering } from '@arrived/models';

import { canOfferingStatusReserveShares } from './canOfferingStatusReserveShares';
import { canTransactForOffering } from './canTransactForOffering';

export const isOfferingForSale = (offering: Offering) => {
  return canTransactForOffering(offering) || canOfferingStatusReserveShares(offering.status);
};
